import { css } from "@emotion/react";
import { useFormContext } from "react-hook-form";
import { Button, Font } from "@moneyforward/mfx_biz_react_components";
import { color } from "@/styles/theme";
import { PasswordFormField } from "@/components/molecules";
import { passwordValidation } from "@/components/validations";

type FormValues = {
  password: string;
};

type Props = {
  onSubmit?: ({ password }: FormValues) => void;
};

export const UpdatePasswordForm = ({ onSubmit }: Props) => {
  const { handleSubmit, formState } = useFormContext();
  return (
    <div css={container}>
      <div css={box}>
        <form onSubmit={handleSubmit(onSubmit)} css={form}>
          <div>
            <PasswordFormField
              name="password"
              usePasswordMeter={true}
              requiredLabel={true}
              registerOptions={{
                validate: passwordValidation,
              }}
            />
          </div>
          <div css={buttonWrapper}>
            <Button type="submit" disabled={formState.isSubmitting}>
              変更
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

const container = css({
  display: "flex",
  justifyContent: "center",
});

const box = css({
  width: "640px",
  padding: "18px 32px",
  border: `1px solid ${color.iron}`,
  borderRadius: "4px",
});

const form = css({
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
});

const buttonWrapper = css({
  display: "flex",
  justifyContent: "flex-end",
  marginTop: "8px",
});
